import api from './client';

// Entities API
export const entitiesAPI = {
  getAll: () => api.get('/entities'),
};

// Bank Accounts API
export const bankAccountsAPI = {
  getAll: (entityId, scope) => api.get('/bank-accounts', { params: { entity_id: entityId, scope } }),
  sync: () => api.post('/bank-accounts/sync'),
  getSummary: (params) => api.get('/bank-balances/summary', { params }),
  assign: (accountId, body) => api.patch(`/admin/bank-accounts/${encodeURIComponent(accountId)}/assign`, body),
  // Bank Account Management (per-account archive control)
  managementList: () => api.get('/admin/bank-accounts'),
  archiveAccount: (accountId) => api.post(`/admin/bank-accounts/${encodeURIComponent(accountId)}/archive`),
  unarchiveAccount: (accountId) => api.post(`/admin/bank-accounts/${encodeURIComponent(accountId)}/unarchive`),
  bridgePreview: () => api.get('/admin/bank-accounts/bridge-accounts-preview'),
  archiveBridge: () => api.post('/admin/bank-accounts/archive-bridge'),
};

// Categorization Rules API
export const categorizationRulesAPI = {
  list: () => api.get('/categorization-rules'),
  create: (data) => api.post('/categorization-rules', data),
  update: (id, data) => api.put(`/categorization-rules/${id}`, data),
  delete: (id, { hard = false } = {}) =>
    api.delete(`/categorization-rules/${id}${hard ? '?hard=true' : ''}`),
  fromTransaction: (txId) => api.post(`/categorization-rules/from-transaction/${txId}`),
  previewBackfill: (data) => api.post('/categorization-rules/preview-backfill', data),
  applyBackfill: (data) => api.post('/categorization-rules/apply-backfill', data),
  previewRevert: (runId) => api.post(`/categorization-rules/preview-revert/${runId}`),
  applyRevert: (runId) => api.post(`/categorization-rules/apply-revert/${runId}`),
  diagnostics: () => api.get('/categorization-rules/diagnostics'),
};

// Gmail entity assignment: "Set entity" row action, mailbox mapping admin
// card, and the entity picker options they share.
export const gmailEntityAssignmentAPI = {
  setEntity: (docId, entityId, applyToCounterparty = false) =>
    api.post('/gmail-entity-assignment/set-entity', {
      doc_id: docId, entity_id: entityId, apply_to_counterparty: applyToCounterparty,
    }),
  getMailboxMappings: () => api.get('/gmail-entity-assignment/mailbox-mappings'),
  setMailboxMapping: (mailbox, entityId) =>
    api.post('/gmail-entity-assignment/mailbox-mappings', { mailbox, entity_id: entityId }),
  getEntities: () => api.get('/gmail-entity-assignment/entities'),
  previewBackfill: () => api.post('/admin/diagnostics/gmail-entity-backfill', { dry_run: true }),
  applyBackfill: () => api.post('/admin/diagnostics/gmail-entity-backfill', { dry_run: false }),
};

// pdf_bill_to entity-resolution backfill: chunked-chain re-run of the
// resolver with the PDF attachment fetched, for the population the
// synchronous gmailEntityAssignmentAPI backfill above can never resolve
// (no text signal, entity name only appears in the PDF's Bill-to block).
export const gmailPdfBillToBackfillAPI = {
  start: () => api.post('/admin/diagnostics/gmail-pdf-bill-to-backfill/start'),
  status: () => api.get('/admin/diagnostics/gmail-pdf-bill-to-backfill/status'),
  stop: (chainId) => api.post('/admin/diagnostics/gmail-pdf-bill-to-backfill/stop', { chain_id: chainId }),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/gmail-pdf-bill-to-backfill/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/gmail-pdf-bill-to-backfill/job-latest'),
};

// Review Queue API
export const reviewAPI = {
  getQueue: (params) => api.get('/review/queue', { params }),
  approve: (id, corrections = null) =>
    api.put(`/review/${id}`, { action: 'approve', corrections }),
  reject: (id, rejectionReason = '') =>
    api.put(`/review/${id}`, { action: 'reject', rejection_reason: rejectionReason }),
  reverseAutoReject: (id) => api.post(`/review/${id}/reverse-auto-reject`),
};
